import { parsePastedText } from "./deviceImportUtils";

const ExcelJS = require("exceljs");

// Cell text keeps a pin such as 0042 as typed, where the numeric value would drop the leading zeros.
const readWorkbook = async (buffer: ArrayBuffer): Promise<string[][]> => {
  const workbook = new ExcelJS.Workbook();
  await workbook.xlsx.load(buffer);
  const sheet = workbook.worksheets[0];
  const rows: string[][] = [];
  sheet?.eachRow({ includeEmpty: false }, (row: any) => {
    rows.push([1, 2].map((column) => String(row.getCell(column).text ?? "").trim()));
  });
  return rows;
};

// Reads the first two columns (serial, pin) of a .csv or .xlsx file; a serial/pin header row is dropped.
export const readImportFile = async (file: File): Promise<string[][]> => {
  if (/\.xlsx$/i.test(file.name)) {
    const rows = await readWorkbook(await file.arrayBuffer());
    return parsePastedText(rows.map((cells) => cells.join("\t")).join("\n"));
  }
  return parsePastedText(await file.text());
};
